"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'userGroup.error.create': 'Błąd podczas tworzenia grupy użytkowników',
};
